import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { formatCuit } from "../pago_proveedores/utils";
import { liberarCuitListaNegra } from "./ApiServices";

export default function ModalLiberar({ open, onClose, emisor, onOk }) {
  const [motivo, setMotivo] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setMotivo("");
    setError("");
  }, [open, emisor]);

  const cuit = emisor?.cuit ?? emisor?.cuit_librador ?? "";

  const guardar = async () => {
    const motivoTrim = motivo.trim();
    if (!motivoTrim) {
      setError("Indique el motivo de la rehabilitación");
      return;
    }
    if (!cuit) return;

    setGuardando(true);
    setError("");
    try {
      const data = await liberarCuitListaNegra(cuit, { motivo: motivoTrim });
      onOk?.(data);
      onClose?.();
    } catch (err) {
      setError(err.message || "Error al rehabilitar el CUIT");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={guardando ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Rehabilitar emisor</DialogTitle>
      <DialogContent dividers>
        {error ? (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        ) : null}
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          El CUIT{" "}
          <strong>{formatCuit(cuit) || cuit || "—"}</strong>
          {emisor?.razon_social ? ` (${emisor.razon_social})` : ""} volverá a
          poder operar cheques. Esta acción queda registrada en el historial.
        </Typography>
        <TextField
          size="small"
          fullWidth
          required
          multiline
          minRows={3}
          label="Motivo de la rehabilitación"
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
          disabled={guardando}
          placeholder="Ej.: Cliente histórico, regularizó con transferencia el mismo día"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={guardando}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={guardar}
          disabled={guardando || !motivo.trim()}
          startIcon={
            guardando ? <CircularProgress size={16} color="inherit" /> : null
          }
        >
          Rehabilitar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
